import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from '../../components/navbar/Navbar'
import Footer from '../../components/footer/Footer'
import { IProduct } from '../../types/products'
import { useDeviceDetect } from '../../utils/use-device-detect'
import NavbarMobile from '../../components/navbar/NavbarMobile/NavbarMobile'
import Sidebar from '../../components/sidebar/Sidebar'
import './MainLayout.scss'
import ContactsButton from '../../components/contacts-button/ContactsButton'
import { HomePandaSign } from '../../components/panda-sign/HomePandaSign'
import { FloatingPandaSign } from '../../components/panda-sign/FloatingPandaSign'
import { PandaSign } from '../../components/panda-sign/PandaSign'
import { getStorageKey } from '../../utils/appType'

type Props = {
  cart: IProduct[]
}
const MainLayout = (props: Props) => {
  const generalInfo = JSON.parse(
    localStorage.getItem(getStorageKey('info')) || '{}',
  )
  const { isMobile, isTablet } = useDeviceDetect()
  const location = useLocation()
  const [searchValue, setSearchValue] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('body-no-scroll')
    } else {
      document.body.classList.remove('body-no-scroll')
    }
  }, [isOpen])

  useEffect(() => {
    if (!location.pathname.includes('checkout')) {
      sessionStorage.removeItem('orderCompleted')
    }
  }, [location.pathname])

  return (
    <div className='main-layout'>
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className='body-container'>
        {!(isMobile || isTablet) ? (
          <Navbar searchValue={searchValue} setSearchValue={setSearchValue} />
        ) : (
          <NavbarMobile
            setIsOpen={setIsOpen}
            cart={props.cart}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        )}
        <Outlet context={{ searchValue }} />
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: '80px',
          right: '120px',
          transform: 'translateX(0)',
          transition: 'transform 0.3s ease-in-out',
          zIndex: 1001,
          pointerEvents: 'auto',
        }}
      >
        {!isMobile && generalInfo.homePromoMessage && (
          <PandaSign message={generalInfo.homePromoMessage} style={{}} />
        )}
      </div>
      {!(isMobile || isTablet) && <Footer />}
      {isMobile && <ContactsButton />}
      {isMobile && generalInfo.homePromoMessage && (
        <FloatingPandaSign message={generalInfo.homePromoMessage} />
      )}
    </div>
  )
}

export default MainLayout
